import { PintoEbookCollectionQuery } from '../../../core/graphql/types';
import { PINTO_BOOK_BASE_URL } from '../../ebooks/presenters/AboutDetailPresenter';

export interface IKOLUserDetailPresenterProps {
  collectionData: NonNullable<PintoEbookCollectionQuery['pintoEbookCollection']>;
}

function KOLUserDetailPresenter(props: IKOLUserDetailPresenterProps) {
  const { collectionData } = props;

  return (
    <div className="p-24 space-y-24 bg-componentsBgGrouped02 rounded-lg">
      <h2 className="font-dbh text-[20px]">KOL User Information</h2>

      <div className="grid grid-cols-1 gap-16 md:grid-cols-2">
        <div className="space-y-12">
          <div>
            <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">User ID</label>
            <a target="_blank" className="block" href={`${PINTO_BOOK_BASE_URL}/user/${collectionData.user.username}?tab=ebook-collections`} rel="noreferrer">
              <p className="font-tt text-colorsBrandWarmBlack01LabelPrimary underline">{collectionData.user._id || 'N/A'}</p>
            </a>
          </div>
          <div>
            <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">Display Name</label>
            <p className="font-tt text-colorsBrandWarmBlack01LabelPrimary">{collectionData.user.displayName || 'N/A'}</p>
          </div>
          <div>
            <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">Username</label>
            <p className="font-tt text-colorsBrandWarmBlack01LabelPrimary">{collectionData.user.username || 'N/A'}</p>
          </div>
        </div>

        <div className="space-y-12">
          <div>
            <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">Email</label>
            <p className="font-tt text-colorsBrandWarmBlack01LabelPrimary">{collectionData.user.email || 'N/A'}</p>
          </div>
          <div>
            <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">User Type</label>
            <p className="font-tt text-colorsBrandWarmBlack01LabelPrimary">{collectionData.user.type}</p>
          </div>
          <div>
            <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">Premium Status</label>
            <p className="font-tt text-colorsBrandWarmBlack01LabelPrimary">{collectionData.user.isPremium ? 'Premium' : 'Standard'}</p>
          </div>
        </div>
      </div>

      {collectionData.user.profileImage && (
        <div>
          <label className="text-sm font-medium text-colorsBrandWarmBlack02LabelSecondary">Profile Image</label>
          <div className="mt-8">
            <img src={collectionData.user.profileImage} alt="Profile" className="w-24 h-24 rounded-full object-cover" />
          </div>
        </div>
      )}
    </div>
  );
}

export default KOLUserDetailPresenter;
